import { inject, injectable } from "tsyringe";
import { DataWarehouseSender } from "./data-warehouse-sender";
import { dataWarehouseUrls } from "./data-warehouse-urls";

@injectable()
export class LoadTimeEventSender {
  constructor(
    @inject(DataWarehouseSender) private readonly sender: DataWarehouseSender,
  ) {}

  send(metricName: string): void {
    const params = {
      event_name: metricName,
      load_time: this.sender.getCurrentTimestamp() - this.sender.getStartTime(),
      ...this.sender.getTimeBasedParams(),
      ...this.sender.getTrackingParams(),
    };

    this.sender.sendEvent(params, dataWarehouseUrls.loadtime);
  }
}
